import { GET_CAMP_READINESS_DASHBOARD_DATA } from '../../../modules/constants';

export function getCampReadinessDashboardData(payload) {
  return {
    type: GET_CAMP_READINESS_DASHBOARD_DATA,
    payload,
  };
}
